import { useContext } from 'react';

import { EditorContextPanelContext } from '@confluence/editor-context-panel/entry-points/EditorContextPanelContext.ts';
import { useDialogs } from '@confluence/dialogs/entry-points/useDialogs.ts';

import { SnippetEditorModal } from '../modals/SnippetEditorModal.tsx';
import { DeleteSnippetModal } from '../modals/DeleteSnippetModal.tsx';
import { SnippetEditorModalMode, type Snippet } from '../snippetTypes.ts';

export type SnippetActionHandlersOptions = {
	contentId: string;
	spaceId: string;
	spaceKey: string;
};

export const useSnippetActionHandlers = ({
	contentId,
	spaceId,
	spaceKey,
}: SnippetActionHandlersOptions) => {
	const { showModal } = useDialogs();
	const { editorAPI } = useContext(EditorContextPanelContext);

	const handleEdit = (snippet: Snippet) => {
		showModal(SnippetEditorModal, {
			mode: SnippetEditorModalMode.EDIT,
			snippet,
			editorAPI,
			contentId,
			spaceId,
			spaceKey,
		});
	};

	const handleDuplicate = (snippet: Snippet) => {
		showModal(SnippetEditorModal, {
			mode: SnippetEditorModalMode.DUPLICATE,
			snippet,
			editorAPI,
			contentId,
			spaceId,
			spaceKey,
		});
	};

	const handleDelete = (snippet: Snippet) => {
		showModal(DeleteSnippetModal, { snippet, editorAPI });
	};

	return { handleEdit, handleDuplicate, handleDelete };
};
